var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b',[_vm._v("#"+_vm._s(_vm.item.id))]),_c('span',[_vm._v(_vm._s(_vm.item.name))]),_c('abbr',[_vm._v(_vm._s(_vm.item.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }